export { Product } from './Product';
export type { ProductProps } from './Product';
